// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"styles_primaryButton__2BsIY","secondaryButton":"styles_secondaryButton__Z0mLT"};